import axiosInstance from '../../../config/axiosInstance';
import { JobValidation } from "../View/Validation/JobValidation";

const handleChange = (event, formData, setFormData) => {
  const { name, value } = event.target;
  setFormData({
    ...formData,
    [name]: value,
  });
};

const handleSubmit = async (event, formData, setFormData, setErrors,redirectCallback,redirectRoleList) => {
  
  event.preventDefault();
  const formErrors = JobValidation(formData);
  setErrors(formErrors);
  if (Object.keys(formErrors).length === 0) {
    try {
      const CompanyID=localStorage.getItem("CompanyID");
      formData.formData.ClientID=CompanyID;
      const UserID=localStorage.getItem("UserID");
      formData.formData.IssueCreatorUserID=UserID;
      const CompanyName=localStorage.getItem("CompanyName");
      formData.formData.CompanyName=CompanyName;
      const response = await axiosInstance.post(`/Job/CreateJob`, formData);
     localStorage.setItem('JobID', response.data.JobID);
      return response.data.message;
    } catch (error) {
      console.error('Error posting data:', error);
    }
  }
};

export { handleChange, handleSubmit };